/* eslint-disable jsx-a11y/img-redundant-alt */
import { Container, Row, Col } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import meter1 from "../assets/img/meter1.png";
import meter2 from "../assets/img/meter2.png";
import meter3 from "../assets/img/meter3.png";
import meter4 from "../assets/img/meter4.png";

// import colorSharp from "../assets/img/color-sharp.png";
export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <section className="services" id="services">
      <Container>
        <Row>
          <Col>
            <div className="services-bx">
              <h2>Services</h2>
              <p>
                We provide a wide range of services from Digital Marketing to
                market your brand and Develop a full scale website from scratch
                as per your requirement.
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="services-slider"
              >
                <div className="item">
                  <img src={meter1} alt="image" />
                  <h5>Digital Marketing</h5>
                </div>
                <div className="item">
                  <img src={meter2} alt="image" />
                  <h5>UI/UX Designing</h5>
                </div>
                <div className="item">
                  <img src={meter3} alt="image" />
                  <h5>Social Media Mangement</h5>
                </div>
                <div className="item">
                  <img src={meter4} alt="image" />
                  <h5>Full Stack Development</h5>
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
      {/* <img className="background-image-left" src={colorSharp} /> */}
    </section>
  );
};
